import {
  Module, VuexModule, Mutation, MutationAction, Action,
} from 'vuex-module-decorators';
import { VueConstructor } from 'vue';
import { CancelTokenSource, CancelToken } from 'axios';
import { ProjectMenu } from '@/models/project';
import { getProjectNameList } from '@/configs/api-path';
import { version as appVersion } from '../../../package.json';

type SessionMessageType = 'success' | 'danger';

interface SessionMessage {
  type: SessionMessageType;
  message: string;
}

interface RequestCancelToken {
  source: CancelTokenSource;
  path: string;
}

@Module({ namespaced: true, name: 'app' })
export default class AppModule extends VuexModule {
  public appVersion: string = appVersion;

  public menuProjects: ProjectMenu[] = [];

  public cancelTokens: RequestCancelToken[] = [];

  public sessionMessage: SessionMessage | null = null;

  get getSessionMessage() {
    return this.sessionMessage;
  }

  get getMenuProjectsAll(): ProjectMenu[] {
    return this.menuProjects;
  }

  get getMenuProjectsLastest(): ProjectMenu[] {
    return this.menuProjects.filter((project) => project.outdated === false);
  }

  get getMenuProjectsOutdated(): ProjectMenu[] {
    return this.menuProjects.filter((project) => project.outdated === true);
  }

  get getAppVersion() {
    return this.appVersion;
  }

  get hasCancelTokens() {
    return this.cancelTokens.length > 0;
  }

  @Mutation
  setSessionMessage(payload: SessionMessage) {
    this.sessionMessage = payload;
  }

  @Mutation
  clearSessionMessage() {
    this.sessionMessage = null;
  }

  @Mutation
  setProjectMenu(projectList: ProjectMenu[]) {
    this.menuProjects = projectList;
  }

  @Mutation
  addCancelToken(token: RequestCancelToken) {
    this.cancelTokens.push(token);
  }

  @Mutation
  deleteCancelToken(token: CancelToken) {
    const index = this.cancelTokens.findIndex((cancelToken) => cancelToken.source.token === token);

    if (index > -1) {
      this.cancelTokens.splice(index, 1);
    }
  }

  @Mutation
  clearCancelToken() {
    this.cancelTokens = [];
  }

  @MutationAction({ mutate: ['menuProjects'] })
  // eslint-disable-next-line class-methods-use-this
  async fetchMenuProjects(vm: VueConstructor) {
    try {
      const { data: menuProjectResponse } = await vm.$axios.get<{
        code: 0;
        project: ProjectMenu[];
      }>(getProjectNameList);

      if (menuProjectResponse.code === 0) {
        return {
          menuProjects: menuProjectResponse.project,
        };
      }

      vm.$notify.show('error filled', '無法取得建案', '取得建案列表', { duration: 3000, permanent: false });
      return {
        menuProjects: [],
      };
    } catch (error) {
      console.error(error);

      vm.$notify.show('error filled', '無法取得建案', '取得建案列表', { duration: 3000, permanent: false });

      return {
        menuProjects: [],
      };
    }
  }

  @Action({ commit: 'clearCancelToken' })
  async cancelAllRequest(message?: string) {
    this.cancelTokens.forEach((token) => {
      if (token.source.cancel) {
        token.source.cancel(message);
      }
    });
  }
}
